/*
Monotype Foundry Platform API
Version 1.0.0

Definition: CreateBinaryRequest

Properties:
  binaries: array
*/

var CreateBinaryRequest = (function () {
  function validateCreateBinaryRequest (arg) {
    // Validate binaries
    if (arg.binaries && !(Array.isArray(arg.binaries))) {
      throw new Error('CreateBinaryRequest.binaries: Wrong type: Got \'' + (typeof arg.binaries) + '\', but expected: \'array\'')
    }
  }
  function buildCreateBinaryRequest (arg) {
    var CreateBinaryRequest = arg
    // Complete binaries
    // Expected Type: array
    CreateBinaryRequest.binaries = CreateBinaryRequest.binaries || []
    return CreateBinaryRequest
  }
  return {
    validate: validateCreateBinaryRequest,
    build: buildCreateBinaryRequest
  }
})()

module.exports = CreateBinaryRequest
